
/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME
// GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME


const GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME= createAsyncThunk(
  "getAllReferralSectionsWithCreatorBySectionName/getAllReferralSectionsWithCreatorBySectionName",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getAllReferralSectionsWithCreatorBySectionNameSlice = createSlice({
  name: "getAllReferralSectionsWithCreatorBySectionNameSlice",
  initialState: {
    getAllReferralSectionsWithCreatorBySectionName: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetAllReferralSectionsWithCreatorBySectionName: (state) => {
        state.getAllReferralSectionsWithCreatorBySectionName.loading = false
        state.getAllReferralSectionsWithCreatorBySectionName.error = false
        state.getAllReferralSectionsWithCreatorBySectionName.data = []
        state.getAllReferralSectionsWithCreatorBySectionName.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME.fulfilled, (state, action) => {
      state.getAllReferralSectionsWithCreatorBySectionName = {
        ...state.getAllReferralSectionsWithCreatorBySectionName,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME.pending, (state, action) => {
      state.getAllReferralSectionsWithCreatorBySectionName = {
        ...state.getAllReferralSectionsWithCreatorBySectionName,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME.rejected, (state, action) => {
      state.getAllReferralSectionsWithCreatorBySectionName = {
        ...state.getAllReferralSectionsWithCreatorBySectionName,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getAllReferralSectionsWithCreatorBySectionNameAction = {
    GETALLREFERRALSSECTIONSWITHCREATORBYSECTIONNAME,
};

export { getAllReferralSectionsWithCreatorBySectionNameAction };
export default getAllReferralSectionsWithCreatorBySectionNameSlice.reducer;
export const {setInitialStateOfgetAllReferralSectionsWithCreatorBySectionName} = getAllReferralSectionsWithCreatorBySectionNameSlice.actions
